/*-----------------------------------------------------------------
- Comments From
-----------------------------------------------------------------*/
export default {
    message: {
        success: 'Your message was successfully sent.',
        error  : 'Problem on Register',
    },
};
